import { defineMessages } from 'react-intl';

export default defineMessages({
  privacyPolicy: 'Polityka Prywatności Systemu Diagmatic',
  termsOfUse: 'Regulamin Systemu Diagmatic',
  checkbox: 'Akceptuję powyższe zapisy',
  goOn: 'Zapoznałem się, przechodzę dalej',
  goToDiagmatic: 'Przejdź do systemu diagmatic',
});
